import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from "react-bootstrap";
import lstrings from '../../../../utils/LStrings';
import moment from 'moment';
import { merge } from 'lodash';
import UI from '../../../../utils/UiUtils';
import ApiClient from '../../../../utils/ApiClient';
import { FF_PRINT_PDF, VARIABLES_EMPRESAS } from '../../../../config';
import Navegador from './components/navegador/Navegador';
import HeaderDetalle from '../../../../components/header-detalle/HeaderDetalle';
import PanelBienes from './components/PanelBienes';
import PanelBoletinOficial from '../../../../components/panel-boletin-oficial/PanelBoletinOficial';
import PanelDatosEmpresa from './components/PanelDatosEmpresa';
import PanelImpuestos from './components/PanelImpuestos';
import PanelSituacionFinanciera from '../../../../components/panel-situacion-financiera/PanelSituacionFinanciera';
import PanelContactacion from '../../../../components/panel-contactacion/PanelContactacion';
import PanelVinculos from './components/PanelVinculos';
import StatusDialog from '../../../../components/status-dialog/StatusDialog';
import RequestInfoDialog from '../../../../components/request-info-dialog/RequestInfoDialog'
import CrearPDF, { CrearPDFTIPODIALOGO } from './components/pdf/CrearPDF';
import { INFO_KEY } from '../../../../config';
import Restringido from '../../../dashboard/components/restringido/Restringido';

class EmpresasDetalle extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			statusDialogShow: false,
			restringido: false,
			mensaje_restringido: '',
			requestInfoDialog: {
				show: false,
				infoTitle: '',
				infoKey: ''
			},
			fecha: moment(),
			info: {
				datosGenerales: {
					empresa: {
						datos: {
							cuit: props.cuit,
						},
					},
				},
			},
			showPanels: {
				panelDatosEmpresa: null,
				panelBoletinOficial: null,
				panelContactacion: null,
				panelImpuestos: null,
				panelVinculos: null,
				panelBienes: null,
				panelSituacionFinanciera: null,
			},
			hidePanels: [],
			rangoIngresos: [],
			enablePrint: false,
		};
  	}

	componentDidMount() {
		UI.showProgress(true);
		ApiClient.getRangoIngresos().then((data) => {
			this.setState({
				rangoIngresos: data.reduce((acc, item) => {
					acc[item.nombre] = item.rango;
					return acc;
				}, {}),
			});
		});
		ApiClient.getCompany(this.props.cuit)
		.then(this.onFinishGetCompany)
		.catch(function (error) {
			UI.showProgress(false);
			UI.showError(error);
		});
		ApiClient.getFeatureFlag(FF_PRINT_PDF).then((res) => {
			this.setState({
				enablePrint: res.results[FF_PRINT_PDF],
			})
		})
	}

	onFinishGetCompany = (res) => {
		if (res.result.code === 200) {
		if (res.data) {
			//hay cosas
			this.procesarInfo(res.data);
		} else {
			throw UI.handledError("No se encontraron resultados");
		}
		} else if(res.result.code === 405) {
			this.setState({
				restringido: true,
				mensaje_restringido: res.result.info
			})
		} else {
		throw UI.handledError(res.result.info);
		}
		UI.showProgress(false);
	}

	procesarInfo = (info) => {
		let hidePanels =  this.hideSubPanels(info);
		let showPanels =  this.mostrarPaneles(info);
		let newInfo = merge(this.state.info, info);
		this.setState({ info: newInfo,
		showPanels:showPanels,
		hidePanels:hidePanels
		});
	}

	mostrarPaneles = (info) => {
		let showPanels = {
		panelDatosEmpresa: true,
		panelBoletinOficial: null,
		panelContactacion: null,
		panelImpuestos: null,
		panelVinculos: null,
		panelBienes: null,
		panelSituacionFinanciera: null,
		}

		if (info.boletinOficial || info.boletinOficial === null) {
		showPanels.panelBoletinOficial= true
		}

		if (info.telefonos || info.telefonos === null
			|| info.telefonosAdicionales || info.telefonosAdicionales === null
			|| info.telefonosCelulares || info.telefonosCelulares === null
			|| info.datosGenerales.mails || info.datosGenerales.mails === null) {
		showPanels.panelContactacion= true
		}

		if (info.impuestos || info.impuestos === null) {
		showPanels.panelImpuestos = true
		}

		if (info.vinculos || info.vinculos === null) {
		showPanels.panelVinculos = true
		}

		if (info.bienes && (info.bienes.propiedades || info.bienes.automotores
		|| info.bienes.propiedades === null || info.bienes.automotores === null)) {
		showPanels.panelBienes= true
		}

		if (info.sitFinanciera && ( info.sitFinanciera.facturacion ||
		info.sitFinanciera.bancoOpera ||
		info.sitFinanciera.tarjetas ||
		info.sitFinanciera.facturacion === null||
		info.sitFinanciera.bancoOpera === null||
		info.sitFinanciera.tarjetas === null)) {
		showPanels.panelSituacionFinanciera= true
		}

		if (info.morosidad && (info.morosidad.informacionBcra ||
		info.morosidad.chequesRechazados ||
		info.morosidad.deudoresBancoCentral ||
		info.morosidad.embargos ||
		info.morosidad.juiciosDemandado ||
		info.morosidad.juicioActor ||
		info.morosidad.informacionBcra === null ||
		info.morosidad.chequesRechazados === null ||
		info.morosidad.deudoresBancoCentral === null ||
		info.morosidad.embargos === null ||
		info.morosidad.juiciosDemandado === null ||
		info.morosidad.juicioActor === null)) {
		showPanels.panelMorosidad= true
		}

		return showPanels;
	}

	hideSubPanels = (info) => {
		let result = [];
		if(info.datosGenerales){
		if(info.datosGenerales.mails === undefined){
			result.push(INFO_KEY.mails);
			info.datosGenerales.mails = undefined;
		}
		if(info.datosGenerales.domAlternativos === undefined) {
			result.push(INFO_KEY.domAlternativos);
			info.datosGenerales.domAlternativos = undefined;
		}
		if(info.datosGenerales.situacionFiscal === undefined) {
			result.push(INFO_KEY.situacionFiscal);
			info.datosGenerales.situacionFiscal = undefined;
		}
		if(info.datosGenerales.empAportes === undefined) {
			result.push(INFO_KEY.empAportes);
			info.datosGenerales.empAportes = undefined;
		}
		if(info.datosGenerales.domAportes === undefined) {
			result.push(INFO_KEY.domAportes);
			info.datosGenerales.domAportes = undefined;
		}
		if(info.datosGenerales.actividad === undefined) {
			result.push(INFO_KEY.actividad);
			info.datosGenerales.actividad = undefined;
		}
		if(info.datosGenerales.sueldos === undefined) {
			result.push(INFO_KEY.sueldos);
			info.datosGenerales.sueldos = undefined;
		}
		if(info.datosGenerales.seguridadSocial === undefined) {
			result.push(INFO_KEY.seguridadSocial);
			info.datosGenerales.seguridadSocial = undefined;
		}
		if(info.datosGenerales.art === undefined) {
			result.push(INFO_KEY.art);
			info.datosGenerales.art = undefined;
		}
		}

		if (info.boletinOficial === undefined) {
		result.push(INFO_KEY.parteSociedad);
		info.boletinOficial = undefined;
		}

		if (info.impuestos === undefined ){
		result.push(INFO_KEY.pagosImpuestos);
		info.impuestos = undefined;
		}
		if (info.vinculos === undefined ){
		result.push(INFO_KEY.vinculos);
		info.vinculos = undefined;
		}

		if(info.telefonos === undefined) {
		result.push(INFO_KEY.telefonos);
		info.telefonos = undefined;
		}
		if (info.telefonosCelulares === undefined) {
		result.push(INFO_KEY.telefonosCelulares);
		info.telefonosCelulares = undefined;
		}
		if (info.telefonosAdicionales === undefined) {
		result.push(INFO_KEY.telefonosAdicionales);
		info.telefonosAdicionales = undefined;
		}

		if(info.bienes){
		if(info.bienes.propiedades === undefined) {
			result.push(INFO_KEY.propiedades);
			info.bienes.propiedades = undefined;
		}
		if(info.bienes.automotores === undefined){
			result.push(INFO_KEY.automotores);
			info.bienes.automotores = undefined;
		}
		}

		if(info.sitFinanciera){
		if(info.sitFinanciera.facturacion == undefined) {
			result.push(INFO_KEY.facturacion);
			info.sitFinanciera.facturacion = undefined;
		}
		if(info.sitFinanciera.bancoOpera == undefined) {
			result.push(INFO_KEY.bancoOpera);
			info.sitFinanciera.bancoOpera = undefined;
		}
		if(info.sitFinanciera.tarjetas == undefined) {
			result.push(INFO_KEY.tarjetas);
			info.sitFinanciera.tarjetas = undefined;
		}
		}

		// Oculto panel Veraz en Empresas
		result.push(INFO_KEY.veraz);

		if(info.morosidad) {
		if (info.morosidad.informacionBcra === undefined) {
			result.push(INFO_KEY.informacionBcra);
			info.morosidad.informacionBcra = undefined;
		}
		if (info.morosidad.chequesRechazados === undefined) {
			result.push(INFO_KEY.chequesRechazados);
			info.morosidad.chequesRechazados = undefined;
		}
		if (info.morosidad.deudoresBancoCentral === undefined) {
			result.push(INFO_KEY.deudoresBancoCentral);
			info.morosidad.deudoresBancoCentral = undefined;
		}
		if (info.morosidad.embargos === undefined) {
			result.push(INFO_KEY.embargos);
			info.morosidad.embargos = undefined;
		}
		if (info.morosidad.juiciosDemandado === undefined) {
			result.push(INFO_KEY.juiciosDemandado);
			info.morosidad.juiciosDemandado = undefined;
		}
		if (info.morosidad.juicioActor === undefined) {
			result.push(INFO_KEY.juiciosActor);
			info.morosidad.juicioActor = undefined;
		}
		}

		return result;
	}

	onRequestInfo = (blockName, subBlockName) => {
		this.setState({
		requestInfoDialog: {
			show: true,
			blockName: blockName,
			subBlockName: subBlockName
		}
		});
	}

	onResultRequestInfo = (result) => {
		this.setState({
		requestInfoDialog: {
			show: false
		}
		});

		if (result === false)
		return;

		UI.showProgress(true);
		ApiClient.requestExtraInfo(this.state.info.idLog, this.state.requestInfoDialog.blockName, this.state.requestInfoDialog.subBlockName)
		.then(function (res) {
			UI.showProgress(false);
			if (res.result.code == 200) {
			UI.showAlert(lstrings.solicitar_informacion_ok);
			} else {
			throw UI.handledError(res.result.info);
			}
		})
		.catch(function (error) {
			UI.showProgress(false);
			UI.showError(error);
		});
	}

	onStatusDialogShow = () => {
		this.setState({ statusDialogShow: true });
	}

	onStatusDialogClose = () => {
		this.setState({ statusDialogShow: false });
	}

	onPDF = () => {
		this.setState({
		mostrarPDF: true,
		tipodialogo: CrearPDFTIPODIALOGO.descargar
		})
	}

	onPrint = () => {
		this.setState({
		mostrarPDF: true,
		tipodialogo: CrearPDFTIPODIALOGO.imprimir
		})
	}

	cerrarPDF = () => {
		this.setState({
		mostrarPDF: false
		})
	}

	render() {
		let empresa = this.state.info.datosGenerales.empresa.datos;

		const restringido = <Restringido message={this.state.mensaje_restringido}/>

		const resultado = (

			<div>

				<Navegador
					showPanels={this.state.showPanels}
					onPDF={this.onPDF}
					enablePrint={this.state.enablePrint}
				/>

				<StatusDialog show={this.state.statusDialogShow}
					onClose={this.onStatusDialogClose} idLog={this.state.info.idLog}
					nombre={empresa.razon} cuil={empresa.cuit}
					status={this.state.info.codigo} variables={VARIABLES_EMPRESAS} validacion={this.state.info.variables}
					fecha={this.state.fecha} />

				<RequestInfoDialog show={this.state.requestInfoDialog.show}
					blockName={this.state.requestInfoDialog.blockName}
					subBlockName={this.state.requestInfoDialog.subBlockName}
					onResult={this.onResultRequestInfo} />

				<div className="resultado-busqueda -detalle">
					<HeaderDetalle
						nombre={empresa.razon}
						cuil={empresa.cuit}
						status={this.state.info.codigo}
						onPrint={this.onPrint}
						onStatusDialogShow={this.onStatusDialogShow}
						enablePrint={this.state.enablePrint}
					/>

					{
						this.state.showPanels.panelDatosEmpresa &&
						<PanelDatosEmpresa
							info={this.state.info.datosGenerales}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
							rangoIngresos={this.state.rangoIngresos}
						/>
					}
					{
						this.state.showPanels.panelContactacion && this.state.info.telefonos &&
						<PanelContactacion
							telefonos={this.state.info.telefonos}
							telefonosCelulares={this.state.info.telefonosCelulares}
							telefonosAdicionales={this.state.info.telefonosAdicionales}
							mails={this.state.info.datosGenerales.mails}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					}
					{
						this.state.showPanels.panelImpuestos &&
						<PanelImpuestos
							info={this.state.info.impuestos}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					}
					{
						this.state.showPanels.panelVinculos &&
						<PanelVinculos
							info={this.state.info.vinculos}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					}
					{
						this.state.showPanels.panelBienes &&
						<PanelBienes
							info={this.state.info.bienes}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					}
					{
						this.state.showPanels.panelSituacionFinanciera &&
						<PanelSituacionFinanciera
							info={this.state.info.sitFinanciera}
							morosidad={this.state.info.morosidad}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					}
					{
						this.state.showPanels.panelBoletinOficial && this.state.info.boletinOficial &&
						<PanelBoletinOficial
							boletinOficial={this.state.info.boletinOficial}
							embargos={this.state.info.morosidad.embargos}
							juiciosActor={this.state.info.morosidad.juicioActor}
							juiciosDemandado={this.state.info.morosidad.juiciosDemandado}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					}
				</div>

				<CrearPDF
					mostrarPDF={this.state.mostrarPDF}
					onCerrarPDF={this.cerrarPDF}
					info={this.state.info}
					fecha={this.state.fecha}
					tipodialogo={this.state.tipodialogo}
					showPanels={this.state.showPanels}
				/>
			</div>
    	);

    	const vista = (this.state.restringido) ? restringido : resultado;

		return (
			<div>
				{ vista }
			</div>
		);
	}
}

EmpresasDetalle.propTypes = {
  cuit: PropTypes.any
};

export default EmpresasDetalle;



// WEBPACK FOOTER //
// ./src/scenes/empresas/components/empresas-detalle/EmpresasDetalle.js